import { render, staticRenderFns } from "./CategoryManagementView.vue?vue&type=template&id=4cf990a8&scoped=true"
import script from "./CategoryManagementView.vue?vue&type=script&lang=js"
export * from "./CategoryManagementView.vue?vue&type=script&lang=js"
import style0 from "./CategoryManagementView.vue?vue&type=style&index=0&id=4cf990a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf990a8",
  null
  
)

export default component.exports